import template from './template.rt'
import './styles.css'

const Team = props => template.call({ props })

export default Team
